<template>
    <section>
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.product" placeholder="Product or UPC" @keyup.enter.native="getList"
                              clearable >
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.warehouse" placeholder="Warehouse" @change="getList()"
                               clearable>
                        <el-option v-for="(w,index) in warehouseList" :label="w.address+' '+w.city+' '+w.state "
                                   :value="w.warehouseNo" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker  @change="getList"
                            v-model="filters.date"
                            type="monthrange" value-format="yyyy-MM"
                            align="right"
                            unlink-panels
                            range-separator="to"
                            start-placeholder="start"
                            end-placeholder="end"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportExcel('/excel/exportStorageFee','StorageFee.xls')">Export</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table stripe stripe :data="list" highlight-current-row v-loading="listLoading" style="width: 100%;">
            <el-table-column prop="warehouse" label="Warehouse">
            </el-table-column>
            <el-table-column prop="product_name" label="Product">
            </el-table-column>
            <el-table-column prop="upc" label="UPC">
            </el-table-column>
            <el-table-column prop="qty" label="Qty">
            </el-table-column>
            <el-table-column prop="price" label="Price">
            </el-table-column>
            <el-table-column prop="charge_total" label="Fee">
                <template slot-scope="scope">
                    {{formatMoney(scope.row.charge_total,2)}}
                </template>
            </el-table-column>
            <el-table-column prop="charge_date" label="Date">
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="changePage"
                           :page-size="pageSize" :total="total"
                           style="float:right;">
            </el-pagination>
        </el-col>

    </section>
</template>


<script>
    import {quillEditor} from 'vue-quill-editor'
    import util from '../../common/js/util'
    import {getStorageFeeList,getCurrentWarehouse} from "../../api/warehouseService";
    import ElOption from "element-ui/packages/select/src/option";
    import {defaultPageSize} from "../../globalVar";
    import {postExportExcel} from "../../api/exportService";

    export default {
        components: {ElOption},
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: 'MTD',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: 'YTD',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                banks: [],
                activeName: "first",
                filters: {
                    warehouse: "",
                    date:"",
                    product:""
                },


                firstListLoading: false,

                pageSize: defaultPageSize,
                page: 1,
                total: 0,
                listLoading: false,


                list: [],
                warehouseList:[]


            }
        },
        methods: {
            exportExcel(url,fileName){
                let param = {
                    url:url,
                    fileName:fileName
                }
                postExportExcel(param).then(function(){

                })
            },
            formatMoney: function (s, n) {
                n = n > 0 && n <= 20 ? n : 2;
                s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
                var l = s.split(".")[0].split("").reverse();
                let r = s.split(".")[1];
                let t = "";
                if (s < 0) {
                    l = ((Math.abs(s.split(".")[0])) + "").split("").reverse();
                }
                for (let i = 0; i < l.length; i++) {
                    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
                }
                if (s < 0) {
                    t += "-";
                }
                var result = t.split("").reverse().join("") + "." + r;
                if (result == null || result == undefined || result.indexOf('NaN') >= 0 || result.indexOf('Undefined') >= 0) {
                    result = '0.00';
                }
                return result;
            },
            getWarehouseList(){
                getCurrentWarehouse({}).then((data)=>{
                    if(data.status===200){
                        this.warehouseList = data.result;
                    }
                })
            },
            changePage(val){
                this.page = val;
                this.getList();
            },
            getList() {
                let param = {
                    current:this.page,
                    size:this.pageSize,
                    warehouse:this.filters.warehouse,
                    product_name:this.filters.product
                };
                if(this.filters.date){
                    param.startDate = this.filters.date[0];
                    param.endDate = this.filters.date[1];
                }
                this.listLoading= true;
                getStorageFeeList(param).then((data)=>{
                    this.listLoading= false;
                    if(data.status===200){
                        this.list = data.result.records;
                        this.total = data.result.total;
                    }
                })
            }
        },
        mounted() {
            this.getList();
            this.getWarehouseList();
        }
    }

</script>
<style>

</style>


// WEBPACK FOOTER //
// storageFee.vue?1bafce9e